import React, { useMemo } from 'react';

import Modal from '../shared/modal';
import Autocomplete from '../shared/autocomplete/Autocomplete';
import Button from '../shared/Button';

import './sales.scss';

const SalesFiltersModal = (props) => {
  const {
    open,
    onClose,
    filters,
    onChange,
    onClear,
    users = [],
    surgeons = [],
    labels = [],
    active,
  } = props;

  const userOptions = useMemo(() => (
    users?.map((user) => ({
      value: user.uid,
      label: `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email || user.uid,
    }))
  ), [users]);

  const labelOptions = useMemo(() => (
    labels?.map((label) => ({
      value: label.id,
      label: label.name,
    }))
  ), [labels]);

  const surgeonOptions = useMemo(() => (
    surgeons?.map((surgeon) => ({
      value: surgeon.id,
      label: `${surgeon.title || ''} ${surgeon.firstName || ''} ${surgeon.lastName || ''}`.trim(),
    }))
  ), [surgeons]);

  const updateFilter = (field, value) => {
    onChange({
      ...filters,
      [field]: value,
    });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title='Filter Leads'
      fullWidth
    >
      <div className='sales-filters-modal__container'>
        <div>
          <div className='field__title'>Assigned User</div>
          <Autocomplete
            multiple
            value={filters.owners || []}
            onChange={(value) => updateFilter('owners', value)}
            options={userOptions}
            placeholder='Filter by assigned user'
          />
        </div>

        <div className='m-t-lg'>
          <div className='field__title'>Surgeon</div>
          <Autocomplete
            multiple
            value={filters.surgeons || []}
            onChange={(value) => updateFilter('surgeons', value)}
            options={surgeonOptions}
            placeholder='Filter by surgeon'
          />
        </div>

        <div className='m-t-lg m-b-lg'>
          <div className='field__title'>Labels</div>
          <Autocomplete
            multiple
            value={filters.labels || []}
            onChange={(value) => updateFilter('labels', value)}
            options={labelOptions}
            placeholder='Filter by label'
          />
        </div>

        {/*<div className='sales-filters-modal__switches'>*/}
        {/*  <Input*/}
        {/*    type='switch'*/}
        {/*    value={!!filters.rottingOnly}*/}
        {/*    onChange={() => updateFilter('rottingOnly', !filters.rottingOnly)}*/}
        {/*    placeholder='Show rotting leads only'*/}
        {/*  />*/}
        {/*</div>*/}

        <div className='form__actions'>
          <Button
            type='secondary'
            text='Clear Filters'
            onClick={onClear}
            disabled={!active}
          />
          <Button
            type='submit'
            text='Done'
            onClick={onClose}
          />
        </div>
      </div>
    </Modal>
  );
};

export default SalesFiltersModal;
